module.exports = __webpack_public_path__ + "static/media/rodrigo_de_paul.5e553067.jpg";